module.exports = __webpack_public_path__ + "i18n/ko_75e5ce0b61861d4f789fc2c6428c89a9.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ko.json
// module id = a8i3
// module chunks = 154